import { CentralisationInsurersEnum } from '../enums/centralisation-insurer.enum';
import { InsuranceType } from '../enums/insurance-type.enum';

export const CENTRALISATION_INSURERS_BY_INSURANCE: {
  [key: string]: CentralisationInsurersEnum[];
} = {
  [InsuranceType.HEALTH]: [
    CentralisationInsurersEnum.AGRISANO,
    CentralisationInsurersEnum.AQUILANA,
    CentralisationInsurersEnum.ASSURA,
    CentralisationInsurersEnum.ATUPRI,
    CentralisationInsurersEnum.CONCORDIA,
    CentralisationInsurersEnum.CSS,
    CentralisationInsurersEnum.EGK,
    CentralisationInsurersEnum.GENOSSENSCHAFT,
    CentralisationInsurersEnum.GENOSSENSCHAFT_SLKK,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.HELSANA,
    CentralisationInsurersEnum.INNOVA,
    CentralisationInsurersEnum.KPT,
    CentralisationInsurersEnum.LUZEMER_HINTERLAND,
    CentralisationInsurersEnum.OKK,
    CentralisationInsurersEnum.RHENUSANA,
    CentralisationInsurersEnum.SANITAS,
    CentralisationInsurersEnum.SAVANALS,
    CentralisationInsurersEnum.SLLK,
    CentralisationInsurersEnum.STEFFISBURG,
    CentralisationInsurersEnum.SODALIS,
    CentralisationInsurersEnum.STIFTUNG_KRANKENKASSE_WADENSWIL,
    CentralisationInsurersEnum.SUMISWALDER,
    CentralisationInsurersEnum.SWICA,
    CentralisationInsurersEnum.SYMPANY,
    CentralisationInsurersEnum.VISANA,
    CentralisationInsurersEnum.VITA_SURSELVA,
    CentralisationInsurersEnum.WADENSWILL_KK,
  ],
  [InsuranceType.THIRD_PILLAR]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.IMPERIO,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.PALLADIO,
    CentralisationInsurersEnum.PAX,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.POST_FINANCES,
    CentralisationInsurersEnum.RETRAITES_POPULAIRES,
    CentralisationInsurersEnum.SWISS_LIFE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.VERSICHERUNG_DER_SCHWEIZER_ARZTE_GENOSSENCHAFT,
    CentralisationInsurersEnum.VZ,
    CentralisationInsurersEnum.YOUPLUS,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BENEFITS_ACCOUNT]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.COMPLEMENTARY_HEALTH]: [
    CentralisationInsurersEnum.AGRISANO,
    CentralisationInsurersEnum.AQUILANA,
    CentralisationInsurersEnum.ASSURA,
    CentralisationInsurersEnum.ATUPRI,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.CONCORDIA,
    CentralisationInsurersEnum.CSS,
    CentralisationInsurersEnum.EGK,
    CentralisationInsurersEnum.GENOSSENSCHAFT,
    CentralisationInsurersEnum.GENOSSENSCHAFT_SLKK,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.HELSANA,
    CentralisationInsurersEnum.INNOVA,
    CentralisationInsurersEnum.KPT,
    CentralisationInsurersEnum.LUZEMER_HINTERLAND,
    CentralisationInsurersEnum.OKK,
    CentralisationInsurersEnum.RHENUSANA,
    CentralisationInsurersEnum.SANITAS,
    CentralisationInsurersEnum.SAVANALS,
    CentralisationInsurersEnum.SLLK,
    CentralisationInsurersEnum.STEFFISBURG,
    CentralisationInsurersEnum.SODALIS,
    CentralisationInsurersEnum.STIFTUNG_KRANKENKASSE_WADENSWIL,
    CentralisationInsurersEnum.SUMISWALDER,
    CentralisationInsurersEnum.SWICA,
    CentralisationInsurersEnum.VISANA,
    CentralisationInsurersEnum.WADENSWILL_KK,
  ],
  [InsuranceType.RC_HOUSEHOLD]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.APPENZELLER,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CSS,
    CentralisationInsurersEnum.ELVIA,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.SIMPEGO,
    CentralisationInsurersEnum.SMILE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.VISANA,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUILDING]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CSS,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GVB,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.CONSTRUCTION]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GVB,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.MOTOR_VEHICLE]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.SIMPEGO,
    CentralisationInsurersEnum.SMILE,
    CentralisationInsurersEnum.TAS_TCS,
    CentralisationInsurersEnum.TSM,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.TRAVEL]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.APPENZELLER,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.EUROP_ASSISTANCE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.TAS_TCS,
    CentralisationInsurersEnum.TSM,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.LEGAL_PROTECTION]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.ASSISTA,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.AXA_ARAG,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CAP,
    CentralisationInsurersEnum.COOP,
    CentralisationInsurersEnum.DEXTRA,
    CentralisationInsurersEnum.ELVIA,
    CentralisationInsurersEnum.EMILIA,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.FORTUNA,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.K_TIPP,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.ORION,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.PROTEKTA,
    CentralisationInsurersEnum.TAS_TCS,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.HOUSING_RENTAL]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.FIRSTCAUTION,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.SMARTCAUTION,
    CentralisationInsurersEnum.SWISSCAUTION,
    CentralisationInsurersEnum.SWISSGARANTA,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.VALUABLE_OBJECTS]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.ANIMAL]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.ANIMALIA,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.EPONA,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
    CentralisationInsurersEnum.WAU_MIAU,
  ],
  [InsuranceType.ACCIDENT]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CSS,
    CentralisationInsurersEnum.HELSANA,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.HOTELA,
    CentralisationInsurersEnum.KPT,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.SODALIS,
    CentralisationInsurersEnum.SUVA,
    CentralisationInsurersEnum.SWICA,
    CentralisationInsurersEnum.SYMPANY,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.VISANA,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.HEALTH_ALLOWANCE]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CSS,
    CentralisationInsurersEnum.HELSANA,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.HOTELA,
    CentralisationInsurersEnum.KPT,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.SODALIS,
    CentralisationInsurersEnum.SUVA,
    CentralisationInsurersEnum.SWICA,
    CentralisationInsurersEnum.SYMPANY,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.VISANA,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_THIRD_PILLAR]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_BUILDING]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GVB,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_RENTAL]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.FIRSTCAUTION,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.SMARTCAUTION,
    CentralisationInsurersEnum.SWISSCAUTION,
    CentralisationInsurersEnum.SWISSGARANTA,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_COMPANY_THINGS]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_CYBERSECURITY]: [
    CentralisationInsurersEnum.AIG,
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CHUBB,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_FLEET]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CHUBB,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_CONSTRUCTION_WARRANTY]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_HEALTH]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CSS,
    CentralisationInsurersEnum.HELSANA,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.HOTELA,
    CentralisationInsurersEnum.KPT,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.SODALIS,
    CentralisationInsurersEnum.SUVA,
    CentralisationInsurersEnum.SWICA,
    CentralisationInsurersEnum.SYMPANY,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.VISANA,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_ACCIDENT]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CSS,
    CentralisationInsurersEnum.HELSANA,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.HOTELA,
    CentralisationInsurersEnum.KPT,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.SODALIS,
    CentralisationInsurersEnum.SUVA,
    CentralisationInsurersEnum.SWICA,
    CentralisationInsurersEnum.SYMPANY,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.VISANA,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_ACCIDENT_COMPLEMENTARY]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CSS,
    CentralisationInsurersEnum.HELSANA,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.HOTELA,
    CentralisationInsurersEnum.KPT,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.SODALIS,
    CentralisationInsurersEnum.SUVA,
    CentralisationInsurersEnum.SWICA,
    CentralisationInsurersEnum.SYMPANY,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.VISANA,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_RETIREMENT]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GASTROSOCIAL,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GROUPE_MUTUEL,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.HOTELA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.PAX,
    CentralisationInsurersEnum.RETRAITES_POPULAIRES,
    CentralisationInsurersEnum.SWISS_LIFE,
    CentralisationInsurersEnum.TELLCO,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_MACHINERY]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_MANIFESTATION]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.TSM,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_LOSS]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_LEGAL_PROTECTION]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.ASSISTA,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CAP,
    CentralisationInsurersEnum.COOP,
    CentralisationInsurersEnum.DEXTRA,
    CentralisationInsurersEnum.EMILIA,
    CentralisationInsurersEnum.FORTUNA,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.ORION,
    CentralisationInsurersEnum.PROTEKTA,
    CentralisationInsurersEnum.TAS_TCS,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_RC_COMPANY]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.CHUBB,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_RC_PROFESSIONAL]: [
    CentralisationInsurersEnum.AIG,
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_TRANSPORT]: [
    CentralisationInsurersEnum.AIG,
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_MOTOR_VEHICLE]: [
    CentralisationInsurersEnum.AIG,
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.SMILE,
    CentralisationInsurersEnum.TAS_TCS,
    CentralisationInsurersEnum.TSM,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_TRAVEL]: [
    CentralisationInsurersEnum.ACS,
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EUROP_ASSISTANCE,
    CentralisationInsurersEnum.ERV,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.STARR_INTERNATIONAL,
    CentralisationInsurersEnum.TAS_TCS,
    CentralisationInsurersEnum.TSM,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_CONSTRUCTION]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GVB,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
  [InsuranceType.BUSINESS_TECHNICAL_INSTALLATION]: [
    CentralisationInsurersEnum.ALLIANZ,
    CentralisationInsurersEnum.AXA,
    CentralisationInsurersEnum.BALOISE,
    CentralisationInsurersEnum.EMMENTAL,
    CentralisationInsurersEnum.GENERALI,
    CentralisationInsurersEnum.GVB,
    CentralisationInsurersEnum.HELVETIA,
    CentralisationInsurersEnum.INFRASSURE,
    CentralisationInsurersEnum.LIMMAT,
    CentralisationInsurersEnum.SCHWEIZERISCHE_HAGEL,
    CentralisationInsurersEnum.LA_MOBILIERE,
    CentralisationInsurersEnum.VAUDOISE,
    CentralisationInsurersEnum.ZURICH_ASSURANCE,
  ],
};
